import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=4aab8f92"
import script from "./Bulletin.vue?vue&type=script&lang=js"
export * from "./Bulletin.vue?vue&type=script&lang=js"
import style0 from "./Bulletin.vue?vue&type=style&index=0&id=4aab8f92&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports